.container {
  padding: var(--space-m);

  &.isStandalone {
    padding: 0;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;

  .submit {
    margin-left: var(--space-s);
  }

  .saveToCommon {
    margin-right: auto; // offset to flex-start
  }
}

.splashOverrides {
  margin-bottom: var(--space-m);
}
